import { useState, useEffect } from "react";
import { DrawerComponent, Modal } from "src/components/DialogComponent";
import Button from "src/components/Button";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _, { update } from "lodash";
import { addItemRequest, getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import { selectCurrentUser } from "src/modules/users/selector";
import Form from "src/components/Form";
import {
    selectItems,
} from "src/modules/spItems/selectors";
import {
    myTasks5WayDependListName,
    myTasksDepartmentsListName,
    myTasksDeviationReportDependListName,
    myTasksDeviationReportKpiByTriggerListName,
    myTasksDeviationReportTriggersListName,
    myTasksKpiByTriggerListName,
    myTasksKPIListName,
    myTasksLocationsListName,
    myTasksTriggersListName,
} from "src/api/config/myTasksLists.config";
import { getItems } from "src/modules/spItems/actions";
import { FiveWhyType } from "src/api/config/systemSwitch";
import LoadingOpBg from "src/components/LoadingOpBg";


const TriggerCard = ({ zIndex, type, setRerenderTable, open, setOpen, trigger, setInArchiveCardTrigger, activeTrigger }: any) => {
    const dispatch = useAppDispatch();
    const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
    const [fields, setFields] = useState<any>([
        {
            type: "select",
            require: true,
            key: "Location",
            title: "Локация",
            placeholder: "Не выбрано",
            width: "w-[calc(33%-10px)]",
        },
        {
            type: "select",
            require: true,
            key: "Department",
            title: "Отдел",
            placeholder: "Не выбрано",
            width: "w-[calc(33%-10px)]",
        },
        {
            type: "select",
            require: true,
            key: "Region",
            title: "Участок",
            placeholder: "Не выбрано",
            width: "w-[calc(33%-10px)]",
        },
        {
            type: "input",
            require: true,
            key: "Trigger",
            title:
                (type === FiveWhyType && "Триггер 5Почему") ||
                "Триггер отчета об отклонении",
            placeholder: "Введите триггер",
            width: "w-[calc(50%-10px)]",
        },
        {
            type: "select",
            require: true,
            searchable: true,
            key: "Kpi",
            title: "KPI",
            placeholder: "Не выбрано",
            width: "w-[calc(50%-10px)]",
        },
    ]);
    const [dependenceFields, setDependenceFields] = useState<any>({
        Location: null,
        Department: null,
        Region: null,
        Trigger: null
    });
    const [formData, setFormData] = useState<any>(null);
    const [defaultValues, setDefaultValues] = useState<any>({});
    const [customLoading, setCustomLoading] = useState(false);
    const locations: any = useAppSelector((state) =>
        selectItems(state, myTasksLocationsListName)
    );
    const dependencies: any = useAppSelector((state) =>
        selectItems(state, myTasks5WayDependListName)
    );
    const dependenciesDeviationReport: any = useAppSelector((state) =>
        selectItems(state, myTasksDeviationReportDependListName)
    );
    const departments: any = useAppSelector((state) =>
        selectItems(state, myTasksDepartmentsListName)
    );
    const kpi: any = useAppSelector((state) =>
        selectItems(state, myTasksKPIListName)
    );

    //Расставляем опции селектов локации и статических селектов
    useEffect(() => {
        if (locations.length > 0 && currentUser.id && departments.length > 0) {
            let defaultLocationsIds: number[] = [];
            if (
                currentUser.isLocationAdminMyTasks ||
                currentUser.isLocationEditorMyTasks
            ) {
                if (
                    Array.isArray(currentUser.isLocationAdminMyTasks) &&
                    currentUser.isLocationAdminMyTasks.length > 0
                ) {
                    defaultLocationsIds = [
                        ...defaultLocationsIds,
                        ...currentUser.isLocationAdminMyTasks,
                    ];
                }
                if (
                    Array.isArray(currentUser.isLocationEditorMyTasks) &&
                    currentUser.isLocationEditorMyTasks.length > 0
                ) {
                    defaultLocationsIds = [
                        ...defaultLocationsIds,
                        ...currentUser.isLocationEditorMyTasks,
                    ];
                }
            }
            let unicDefaultLocationsIds: number[] = [
                ..._.uniqWith(defaultLocationsIds, _.isEqual),
            ];
            const defaultDepartments = departments.filter(department => currentUser.department && department.User_Department && department.User_Department.indexOf(currentUser.department) !== -1).map(department => {
                return { id: department.ID, name: department.Title, disabled: false }
            });
            setDefaultValues((prev) => {
                return {
                    ...prev,
                    Location:
                        (unicDefaultLocationsIds.length > 0 &&
                            unicDefaultLocationsIds.map((id) => {
                                return {
                                    id: id,
                                    name: locations.find((location: any) => location.ID === id)[
                                        "Title"
                                    ],
                                    disabled: false,
                                };
                            })[0]) ||
                        null,
                    Department: defaultDepartments.length > 0 && defaultDepartments[0] || null
                };
            });
        }
        if (currentUser.id && kpi.length > 0) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Location") {
                    const options = locations.filter((location: any) => {
                        if (
                            currentUser.isAdmin ||
                            (currentUser.isLocationEditorMyTasks &&
                                currentUser.isLocationEditorMyTasks.length > 0 &&
                                currentUser.isLocationEditorMyTasks.find(
                                    (locationID: any) => locationID === location.ID
                                )) ||
                            (currentUser.isLocationAdminMyTasks &&
                                currentUser.isLocationAdminMyTasks.length > 0 &&
                                currentUser.isLocationAdminMyTasks.find(
                                    (locationID: any) => locationID === location.ID
                                ))
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    }).map((location: any) => {
                        return {
                            id: location.ID,
                            name: location.Title,
                            available: true,
                        };
                    });
                    tempFieldsForm[i]["options"] = [...options];
                }
                if (tempFieldsForm[i]["key"] === "Kpi") {
                    const options = kpi.map((item: any) => {
                        return {
                            id: item.ID,
                            name: item.Title,
                            available: true,
                        };
                    });
                    tempFieldsForm[i]["options"] = [...options];
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [locations, currentUser, departments, kpi]);

    useEffect(() => {
        const tempFieldsForm = [...fields];
        if (currentUser.isAdmin || (currentUser.isLocationEditorMyTasks &&
            currentUser.isLocationEditorMyTasks.length > 0 &&
            currentUser.isLocationEditorMyTasks.find(
                (locationID: any) => trigger.Location && locationID === trigger.Location.get_lookupId()
            )) ||
            (currentUser.isLocationAdminMyTasks &&
                currentUser.isLocationAdminMyTasks.length > 0 &&
                currentUser.isLocationAdminMyTasks.find(
                    (locationID: any) => trigger.Location && locationID === trigger.Location.get_lookupId()
                ))) {
            if (dependenceFields["Location"]) {
                dispatch(
                    getItems({
                        listName:
                            (type === FiveWhyType && myTasks5WayDependListName) ||
                            myTasksDeviationReportDependListName,
                        filters: { Location: dependenceFields["Location"]["id"] },
                    })
                );

                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Department") {
                        tempFieldsForm[i]["disabled"] = false;
                    }
                    if (tempFieldsForm[i]["key"] === "Region") {
                        tempFieldsForm[i]["disabled"] = true;
                    }
                    if (tempFieldsForm[i]["key"] === "Trigger") {
                        tempFieldsForm[i]["disabled"] = true;
                    }
                }

            }
            if (!dependenceFields["Location"]) {
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (
                        tempFieldsForm[i]["key"] === "Department" ||
                        tempFieldsForm[i]["key"] === "Region" ||
                        tempFieldsForm[i]["key"] === "Trigger"
                    ) {
                        tempFieldsForm[i]["disabled"] = true;
                    }
                }

            }
            if (dependenceFields["Department"]) {
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Region") {
                        tempFieldsForm[i]["disabled"] = false;
                    }
                }

            }
            if (dependenceFields["Region"]) {
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Trigger") {
                        tempFieldsForm[i]["disabled"] = false;
                    }
                }

            }
        } else {
            for (let i = 0; i < tempFieldsForm.length; i++) {
                tempFieldsForm[i]["disabled"] = true;
            }
        }
        setFields([...tempFieldsForm]);
    }, [dependenceFields, currentUser, JSON.stringify(trigger)]);

    //В списке зависимостей колонка называется Departament, а в списках с аудитами и отделами Department (буква a отличие)

    useEffect(() => {
        const tempFieldsForm = [...fields];
        let tempDependencies: any = [];
        if (type === FiveWhyType) {
            tempDependencies = [...dependencies];
        } else {
            tempDependencies = [...dependenciesDeviationReport];
        }
        for (let i = 0; i < tempFieldsForm.length; i++) {
            if (dependenceFields["Location"]) {
                if (tempFieldsForm[i]["key"] === "Department") {
                    const options = tempDependencies
                        .filter(
                            (dependence: any) =>
                                dependence.Location.ID === dependenceFields["Location"]["id"]
                        )
                        .map((dependence: any) => {
                            return {
                                id: dependence.Departament.ID,
                                name: dependence.Departament.Title,
                            };
                        });
                    tempFieldsForm[i]["options"] = (_.uniqWith(options, _.isEqual)
                        .length > 0 &&
                        _.uniqWith(options, _.isEqual)) || [
                            {
                                id: 0,
                                name: "Нет вариантов",
                                available: false,
                            },
                        ];
                }
            }
            if (dependenceFields["Department"]) {
                if (tempFieldsForm[i]["key"] === "Region") {
                    const options = tempDependencies
                        .filter(
                            (dependence: any) =>
                                dependence.Departament.ID ===
                                dependenceFields["Department"]["id"]
                        )
                        .map((dependence: any) => {
                            return {
                                id: dependence.Region.ID,
                                name: dependence.Region.Title,
                            };
                        });
                    tempFieldsForm[i]["options"] = (_.uniqWith(options, _.isEqual)
                        .length > 0 &&
                        _.uniqWith(options, _.isEqual)) || [
                            {
                                id: 0,
                                name: "Нет вариантов",
                                available: false,
                            },
                        ];
                }
            }
        }
        setFields([...tempFieldsForm]);
    }, [
        dependencies,
        dependenciesDeviationReport,
        type
    ]);

    useEffect(() => {
        setDefaultValues({
            Location: { name: trigger.Location.get_lookupValue(), id: trigger.Location.get_lookupId() },
            Department: { name: trigger.Departament.get_lookupValue(), id: trigger.Departament.get_lookupId() },
            Region: { name: trigger.Region.get_lookupValue(), id: trigger.Region.get_lookupId() },
            Trigger: trigger.Trigger.get_lookupValue(),
            Kpi: trigger.Kpi && { name: trigger.Kpi.get_lookupValue(), id: trigger.Kpi.get_lookupId() } || null,
        })
    }, [trigger]);

    useEffect(() => {
        if (formData && Object.keys(formData).length > 0) {
            setCustomLoading(true);
            updateItemRequest({ listName: type === FiveWhyType && myTasksTriggersListName || myTasksDeviationReportTriggersListName, body: { ID: trigger.Trigger.get_lookupId(), Title: formData.Trigger } }).then(triggerId => {
                getItemsRequest({ listName: type === FiveWhyType && myTasksKpiByTriggerListName || myTasksDeviationReportKpiByTriggerListName, filters: { Trigger: trigger.Trigger.get_lookupId() } }).then(results => {
                    const kpiByTrigger = [...results.items];
                    const kpiByTriggerUpdateData = kpiByTrigger.map(item => {
                        return { ID: item.ID, Kpi: formData.Kpi.id }
                    });
                    updateItemRequest({ listName: type === FiveWhyType && myTasksKpiByTriggerListName || myTasksDeviationReportKpiByTriggerListName, body: kpiByTriggerUpdateData[0], bodyArr: kpiByTriggerUpdateData }).then(kpiByTriggerId => {
                        getItemsRequest({ listName: type === FiveWhyType && myTasks5WayDependListName || myTasksDeviationReportDependListName, filters: { Location: trigger.Location.get_lookupId(), Departament: trigger.Departament.get_lookupId(), Region: trigger.Region.get_lookupId(), Trigger: trigger.Trigger.get_lookupId() } }).then(results => {
                            const depend = [...results.items];
                            const dependUpdateData = depend.map(item => {
                                return { ID: item.ID, Location: formData.Location.id, Department: formData.Department.id, Region: formData.Region.id, Trigger: trigger.Trigger.get_lookupId() }
                            });
                            updateItemRequest({ listName: type === FiveWhyType && myTasks5WayDependListName || myTasksDeviationReportDependListName, body: dependUpdateData[0], bodyArr: dependUpdateData }).then(dependId => {
                                setCustomLoading(false);
                                setRerenderTable(false);
                                setOpen(false);
                            });
                        });
                    });
                });
            });
        }
    }, [formData]);

    return (
        <>
            <DrawerComponent
                zIndex={zIndex}
                open={open}
                toggleDrawer={setOpen}
            >
                <div className="flex flex-col p-10 shrink">
                    {customLoading && <LoadingOpBg />}
                    <Form
                        type="card_my_tasks_trigger"
                        setFormData={setFormData}
                        fieldsForm={fields}
                        defaultValues={defaultValues}
                        setDependenceFields={setDependenceFields}
                        openCancelAddCard={open}
                        setOpenCancelAddCard={setOpen}
                        zIndex={zIndex}
                        setInArchiveCardTrigger={setInArchiveCardTrigger}
                        activeTrigger={activeTrigger}
                        trigger={trigger}
                    />
                </div>
            </DrawerComponent>
        </>
    );
};

export default TriggerCard;
